import classnames from 'classnames';
import React, { useCallback } from 'react';
import { IoIosCheckmark as TickIcon } from 'react-icons/io';
import { createUseStyles } from 'react-jss';
import { useDispatch, useSelector } from 'react-redux';

import { useGame } from '../../../context';
import { toggleFilter } from '../../../redux/actions';

const useStyles = createUseStyles({
  button: {
    borderRadius: 4,
    composes: ['is-block', 'mt6', 'fs12', 'py6', 'pl12', 'pr24'],
    transition: 'background 0.3s, color 0.3s',
  },
  icon: {
    marginRight: 6,
    transition: 'color 0.3s',
    verticalAlign: 'middle',
  },
  item: {
    composes: ['px3', 'is-flex'],
    flex: '0 auto',
  },
});

const sortByOrder = (a, b) => {
  if (a.order > b.order) return 1;
  if (a.order < b.order) return -1;
  return 0;
};

const TagsComponent = React.memo(() => {
  const classes = useStyles();
  const { tags } = useGame();
  const dispatch = useDispatch();
  const filters = useSelector(_ => _.filters);

  const clickHandler = useCallback(
    (types, visible) => dispatch(toggleFilter(types, visible)),
    [dispatch]
  );

  return tags.sort(sortByOrder).map(obj => {
    const hidden = obj.items.every(key => filters.includes(key));
    return (
      <div key={obj.id} className={classes.item}>
        <button
          className={classnames(
            classes.button,
            { hidden },
            'smart-maps-tags-filter'
          )}
          type="button"
          onClick={() => clickHandler(obj.items, !hidden)}>
          <TickIcon className={classes.icon} size={22} />
          <i>{obj.label}</i>
        </button>
      </div>
    );
  });
});

TagsComponent.displayName = 'TagsComponent';

export default TagsComponent;
